export default class LoginForm {}

const selectors = {
  hideRecover: '[data-hide-recover]',
  login: '[data-login]',
  recover: '[data-recover]',
  recoverLink: '[data-recover-link]',
  recoverSuccessMessage: '[data-reset-success]',
  showRecoverMessage: 'data-show-form',
};

const activeClass = 'is-hidden';
const login = document.querySelector(selectors.login);

if (login) {
  const recoverLink = login.querySelector(selectors.recoverLink);

  if (recoverLink) {
    recoverLink.addEventListener('click', handleRecoverForm);
  }
}

const recover = document.querySelector(selectors.recover);
const hideRecover = document.querySelector(selectors.hideRecover);
const recoverSuccessMessage = document.querySelector(
  selectors.recoverSuccessMessage,
);

const checkUrlHash = () =>
  window.location.hash === '#recover' ? toggleRecoverForm() : undefined;

function handleRecoverForm(event: Event) {
  event.preventDefault();
  toggleRecoverForm();
}

function toggleRecoverForm(forceShow = false) {
  if (!login || !recover) {
    return;
  }

  if (forceShow) {
    login.classList.add(activeClass);
    recover.classList.remove(activeClass);
    return;
  }

  login.classList.toggle(activeClass);
  recover.classList.toggle(activeClass);
}

function checkRecoverFormSuccessMessage() {
  if (!recoverSuccessMessage) {
    return;
  }

  if (recoverSuccessMessage.hasAttribute(selectors.showRecoverMessage)) {
    toggleRecoverForm(true);
  }
}

function init() {
  if (!recover) {
    return;
  }

  checkUrlHash();
  checkRecoverFormSuccessMessage();

  if (hideRecover) {
    hideRecover.addEventListener('click', handleRecoverForm);
  }
}

init();
